export function articleHelpful() {
   const helpfulArea = document.querySelector("#helpful-area");
   const buttons = document.querySelectorAll(".helpful-button");

   buttons.forEach( button => {
    button.addEventListener( "click", (button) => {
        helpfulArea.innerHTML ="Thank you!";
    });
   });
}